import React, { lazy, Suspense } from "react";
import "./about.css";
import FetchContent from "../dynamic/fetchContent";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import FAQ from "./FAQ";
import Practicalities from "./Practicalities";
import ImageContent from "../dynamic/ImageContent";
import Content from "../dynamic/Content";
import Services from "../home/Services";
import FloorPlan from "./FlowPlan";
const FetchImage = lazy(() => import("../dynamic/fetchImage"));
const DogFriendlyHome = lazy(() => import("./DogsStripe"));
const WheelChairStripe = lazy(() => import("./WheelChairStripe"));
const Parking = lazy(() => import("./Parking"));
const ChildrenBed = lazy(() => import("./childrenBed"));
const EvCharging = lazy(() => import("./EvCharging"));
const BicycleParking = lazy(() => import("./BicycleParking"));


export default function Accommodation() {
  const { username, auth } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="default">
      <div>
        <Suspense fallback={<h1>Still Loading…</h1>}>
          {!auth?.role ? (
            <FetchImage title="accommodation" type="image-about" />
          ) : (
            <ImageContent
              title="accommodation"
              username={username}
              type="image-about"
            />
          )}
        </Suspense>

        <div className="contact-title">
          {" "}
          <h1>{t("accommodation_page.practicalities")}</h1>{" "}
        </div>

        <div className="stripe container about-us-main">
          <div className="about-us-main-img">
            {!auth?.role ? (
              <FetchImage
                title="accommodation-about"
                type="about-us-main-img-container"
              />
            ) : (
              <ImageContent
                title="accommodation-about"
                username={username}
                type="image-about"
              />
            )}
          </div>

          <div className="about-us-main-content">
            {!auth?.role ? (
              <div className="p-brandnew">
                <FetchContent title="p-frontpage" />
              </div>
            ) : (
              <div className="p-brandnew">
                <Content title={"p-frontpage"} styling="p" />
              </div>
            )}
          </div>
        </div>
        {/* <div className="stripe p">
          <h1>{t("accommodation_page.accommodation")}</h1>
          <div className="container">
            <hr></hr>
          </div>
          <div className="p">
            {!auth?.role ? (
              <div className="container p ws-pre-wrap">
                <FetchContent title="p-frontpage" />
              </div>
            ) : (
              <div className="container p ws-pre-wrap">
                <Content title={"p-frontpage"} styling="p" />
              </div>
            )}
          </div>
        </div> */}

        <div className="stripe">
          <Practicalities />
        </div>

        <div className="stripe">
          <FAQ />
        </div>

        <div className="other-services">
          <Services />
        </div>
        <div className="container-service">
          <Suspense fallback={<h1>Still Loading…</h1>}>
            <DogFriendlyHome />
            <ChildrenBed />
            <Parking />
            <WheelChairStripe />
            <BicycleParking />
            <EvCharging />
          </Suspense>
        </div>
        <FloorPlan />
      </div>
    </div>
  );
}
